import React, { useEffect, useRef, useState } from 'react';
import { FaArrowRight, FaSlidersH } from 'react-icons/fa';
import './input.css';

const MODELS = [
  'Conductual básico',
  'Conductual avanzado',
  'Neuroconductual básico',
  'Neuroconductual avanzado',
  'Neuroconductual profundo'
];

const SUGGESTED_QUESTIONS = [
  '¿Cómo mejorar mi comunicación asertiva?',
  '¿Cómo manejar el estrés en equipo?',
  '¿Qué fortalezas comunicativas tengo?'
];

const InputComponent = ({
  messageInput,
  setMessageInput,
  handleKeyDown,
  sendMessage,
  isStreaming,
  selectedModel,
  setSelectedModel,
}) => {
  const descriptionRef = useRef(null);
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.style.height = 'auto';
      descriptionRef.current.style.height = `${descriptionRef.current.scrollHeight}px`;
    }
  }, [messageInput]);

  const toggleSidebar = () => setSidebarOpen(open => !open);
  const handleModelClick = model => {
    setSelectedModel(model);
    setSidebarOpen(false);
  };

  const handleSuggestionClick = suggestion => {
    setMessageInput(suggestion);
    descriptionRef.current.focus();
  };

  return (
    <div className="input-wrapper" style={{ position: 'relative', zIndex: 1 }}>
      {/* Suggested questions */}
      <div
        className="suggestions-container"
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '8px',
          marginBottom: '8px'
        }}
      >
        {SUGGESTED_QUESTIONS.map((q, idx) => (
          <button
            key={idx}
            type="button"
            className="suggestion-box"
            onClick={() => handleSuggestionClick(q)}
            style={{
              fontSize: '0.75rem',
              fontWeight: 300,
              padding: '4px 8px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              background: '#f9f9f9',
              cursor: 'pointer'
            }}
          >
            {q}
          </button>
        ))}
      </div>

      <textarea
        ref={descriptionRef}
        placeholder="Hazme una pregunta conductual..."
        value={messageInput}
        onChange={e => setMessageInput(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isStreaming}
        className="auto-resize-textarea-chat"
        rows={1}
      />
      <button
        onClick={sendMessage}
        disabled={isStreaming}
        className="send-button"
      >
        <FaArrowRight size={15} />
      </button>

      {/* Desktop select with icon inside */}
      <div className="desktop-select">
        <div className="select-with-icon">
          <FaSlidersH className="select-icon" size={16} />
          <select
            value={selectedModel}
            onChange={e => setSelectedModel(e.target.value)}
            className="modelo-select"
            disabled={isStreaming}
          >
            {MODELS.map(model => (
              <option key={model} value={model}>{model}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Mobile toggle button with selected label */}
      <button
        className="mobile-select-toggle"
        onClick={toggleSidebar}
        aria-label="Abrir modelos"
      >
        <FaSlidersH size={20} />
        <span className="selected-model-label">{selectedModel}</span>
      </button>

      {/* Drawer sidebar */}
      <div className={`model-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleSidebar} aria-label="Cerrar">×</button>
        <ul className="model-list">
          {MODELS.map(model => (
            <li
              key={model}
              className={`model-item ${selectedModel === model ? 'selected' : ''}`}
              onClick={() => handleModelClick(model)}
            >
              {model}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InputComponent;

